import {useState } from "react";
import {
  ContainerEstra,
  ContainerTag,
  CustomPiramide,
  LevelButton,
  TagEstrategia,
} from "./piramide-full.styled";

import piramidefull from "../../../assets/img/piramide.svg";
import { DataPiramide } from './piramide-full.styled';
import { ColorEstrategia, Estrategias } from './data';


const BCPiramideFull = () => {
  const [viewPiramide, setViewPiramide] = useState(false);

  return (
    <ContainerEstra>
      <h1>Plan Estratégico de Marketing 2024</h1>
      <DataPiramide className={ viewPiramide ? 'piramide-full' : ''}>
      <ContainerTag>
        {Estrategias.map((estrategia: any) => (
            <TagEstrategia key={estrategia.name} className={ viewPiramide ? 'piramide-full' : ''} style={{backgroundColor: viewPiramide ? ColorEstrategia(estrategia.level) : '',borderColor: viewPiramide ? ColorEstrategia(estrategia.level) : '', transform: viewPiramide ? `translate(${estrategia.x}px, ${estrategia.y}px)` : '' }} >{estrategia.name} - {estrategia.score}</TagEstrategia>
            ))}
        </ContainerTag>
      </DataPiramide>
      <CustomPiramide className={ viewPiramide ? 'piramide-full' : ''}>
        <div className="piramide">
          <LevelButton
            onClick={() => setViewPiramide(!viewPiramide)}
            className={ viewPiramide ? 'piramide-full' : ''}
            type="button"
            title="nivel1"
          >
            <img src={piramidefull} alt="piramidefull" />
          </LevelButton>
        </div>
      </CustomPiramide>
    </ContainerEstra>
  );
};

export default BCPiramideFull;
